<template>
  <fieldset class="tla-form-group tla-form-group tla-form-group--margin-medium">
    <label
      v-if="!hideLabel"
      class="tla-form-group__label tla-form-group__label--required"
      v-html="formattedPurchaseTimeLabel"
    ></label>

    <div v-if="useDropdown" class="tla-form-group">
      <select
        id="purchaseTimescale"
        class="tla-form-group__input tla-form-group__input--arrow"
        :class="getValidationClass('purchaseTime', 'input')"
        v-validate.continues="'required|min:1'"
        :data-vv-scope="validationScope"
        v-model="purchaseTime"
        name="purchaseTimescale"
      >
        <option disabled selected value="null">
          {{ formattedPurchaseTimePlaceholder }}
        </option>
        <option
          v-for="item in purchaseTimeOptions"
          :value="item.touchpointValue"
          :key="item.touchpointValue"
        >
          {{ item.touchpointName }}
        </option>
      </select>
    </div>

    <div v-else class="tla-form-group__touch-points">
      <touchpoint
        v-for="item in purchaseTimeOptions"
        :key="item.touchpointValue"
        :collectionName="'purchaseTime'"
        :inputId="item.touchpointValue"
        :inputValue="item.touchpointValue"
        :isSelected="item.preSelect"
        :validationScope="validationScope"
        @purchaseTime="submitPurchaseTimeValue($event)"
      >
        <touchpointText
          slot="touchpoint"
          :content="item.touchpointName"
        ></touchpointText>
      </touchpoint>
    </div>
    <span
      class="tla-form-group__message"
      :class="getValidationClass('purchaseTime', 'message')"
    >
      Please select an option.
    </span>
  </fieldset>
</template>

<script lang='ts'>
import {
  Component, Prop, Vue, Watch, Inject
} from 'vue-property-decorator';
import { Validator } from 'vee-validate';
import KeyValue from '@/models/KeyValue';
import { validationService } from '@/services/ValidationService';
import PurchaseTime from '@/enums/PurchaseTime';
import { tokenService } from '../../services/TokenService';
import GenericTouchPointComponent from '../ui/GenericTouchPointComponent.vue';
import GenericTouchPointTextComponent from '../ui/GenericTouchPointTextComponent.vue';
import Touchpoint from '../../models/Touchpoint';

@Component({
  components: {
  touchpoint: GenericTouchPointComponent,
  touchpointText: GenericTouchPointTextComponent
  }
  })
export default class PurchaseTimeComponent extends Vue {
  @Inject('$validator') public $validator!: Validator;

  @Prop({ default: null })
  public validationScope!: string;

  @Prop({ default: 'When are you looking to change your vehicleType?' })
  public purchaseTimeLabel!: string;

  @Prop({ default: false })
  public useDropdown!: boolean;

  @Prop({ default: false })
  public hideLabel!: boolean;

  @Prop({ default: 'Please select an option' })
  public purchaseTimePlaceholder!: string;

  @Prop({
    default: () => [
      new KeyValue('ASAP', '1'),
      new KeyValue('Next 3 Months', '4'),
      new KeyValue('Next 6 Months', '5'),
      new KeyValue('6 Months+', '6')
    ]
  })
  public options!: KeyValue[];

  public purchaseTimeLabelFormatted!: string;

  public get purchaseTime(): string | null {
    const time: PurchaseTime = this.$store.getters['enquiryModule/purchaseTime'];
    return time ? time.toString() : null;
  }

  public set purchaseTime(timescale: string | null) {
    this.submitPurchaseTimeValue(timescale || PurchaseTime.NotSpecified.toString());
    this.$validator.validateAll(this.validationScope);
  }

  public get purchaseTimeOptions(): Touchpoint[] {
    return this.options.map(
      (a: KeyValue) => new Touchpoint(a.value, tokenService.replaceToken(a.key))
    );
  }

  public get formattedPurchaseTimeLabel() {
    return tokenService.replaceToken(this.purchaseTimeLabel);
  }

  public get formattedPurchaseTimePlaceholder() {
    return tokenService.replaceToken(this.purchaseTimePlaceholder);
  }

  public submitPurchaseTimeValue(value: string) {
    this.$store.dispatch(
      'enquiryModule/submitPurchaseTime',
      parseInt(value, 10)
    );
  }

  public getValidationClass(fieldName: string, fieldType: string) {
    return validationService.getValidationClass(
      this.$validator,
      fieldName,
      fieldType,
      false,
      false,
      this.validationScope
    );
  }
}
</script>
